var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34168 18.6666C7.8423 18.6666 8.17605 18.3333 8.17605 17.8333C8.17605 17.3333 7.8423 16.9999 7.34168 16.9999H3.1698C2.66917 16.9999 2.33542 16.6666 2.33542 16.1666V2.83325C2.33542 2.33325 2.66917 1.99992 3.1698 1.99992H7.34168C7.8423 1.99992 8.17605 1.66659 8.17605 1.16659C8.17605 0.666585 7.8423 0.333252 7.34168 0.333252H3.1698C1.75136 0.333252 0.666668 1.41659 0.666668 2.83325V16.1666C0.666668 17.5833 1.75136 18.6666 3.1698 18.6666H7.34168ZM17.2708 9.16658C17.3542 9.41658 17.3542 9.66658 17.2708 9.83325C17.2708 9.91658 17.1873 9.99992 17.1039 10.0833L13.7664 13.4166C13.5995 13.5833 13.3492 13.6666 13.1823 13.6666C13.0154 13.6666 12.7651 13.5833 12.5982 13.4166C12.2645 13.0833 12.2645 12.5833 12.5982 12.2499L14.5173 10.3333H6.5073C6.00668 10.3333 5.67293 9.99992 5.67293 9.49992C5.67293 8.99992 6.00668 8.66658 6.5073 8.66658H14.5173L12.5982 6.74992C12.2645 6.41659 12.2645 5.91659 12.5982 5.58325C12.932 5.24992 13.4326 5.24992 13.7664 5.58325L17.1039 8.91658C17.1456 8.95825 17.1665 8.99992 17.1873 9.04158C17.2082 9.08325 17.229 9.12492 17.2708 9.16658Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.108b63ba4a5c092dcf0a9833414d0cae.svg";
export { ForwardRef as ReactComponent };